export const fileIcons: Record<string, string> = {
    zip: 'folder_zip',
    rar: 'folder_zip',
    htm: 'html',
    html: 'html',
    js: 'javascript',
    json: 'data_object',
    md: 'markdown',
    pdf: 'draft',
    png: 'image',
    jpg: 'image',
    jpeg: 'image',
    mp4: 'movie',
    mkv: 'movie',
    avi: 'movie',
    wmv: 'movie',
    mov: 'movie',
    txt: 'description',
    xls: 'two_pager',
    other: 'unknown_document'
}

export const formatBytes = (bytes: number, decimals: number = 2) => {
    if (bytes === 0) return '0 bytes'

    const k = 1024
    const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
}

export const downloadFileNewTab = (file: File, filename: string) => {
    const url = window.URL.createObjectURL(file)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('id', 'download-link')
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    setTimeout(() => {
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
    }, 250)
}
